import { getSelectedPeople } from '../people/selectors';
import * as types from './types';
import { ADD_AWARD_TO_PERSON } from '../people/types';

export const setAwardValue = ( awardValue ) => ( { type: types.SET_AWARD_VALUE, awardValue } );
export const setAllocatePoints = ( value ) => ( dispatch ) => dispatch( { type: types.SET_ALLOCATE_POINTS, value } );
export const setPersonPoints = ( personId, awardValue ) => ( { type: ADD_AWARD_TO_PERSON, personId, awardValue } );
export const setPointsForPerson = ( personId, value ) => ( dispatch, getState ) => {
    const selectedPeople = getSelectedPeople( getState() );
    if ( personId === 'all' )
    {
        dispatch( setAwardValue( value ) );
    }
    for ( let i = 0; i < selectedPeople.length; i++ ) {
        if ( personId === 'all' )
        {
            dispatch( setPersonPoints( selectedPeople[ i ].id, value ) );
        }
        else { 
            if ( selectedPeople[ i ].id === personId ) 
            {
                dispatch( setPersonPoints( personId, value ) );
                break;
            }
        }
    }
};